module.exports = __webpack_public_path__ + "static/media/TP_Icon_Tote.a98d213c.png";